import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment } from "vue";
import _imports_0 from '../../assets/pc/common/logox.png';
import _imports_1 from '@/assets/phone/common/nav_right.png';
import _imports_2 from '@/assets/phone/common/nav_black.png';
import _imports_3 from '@/assets/phone/common/close.png';
import _imports_4 from '@/assets/phone/common/plus.png';
import _imports_5 from '@/assets/phone/common/reduce.png';
const _hoisted_1 = {
  key: 0,
  class: "right_logo",
  src: _imports_1,
  alt: ""
};
const _hoisted_2 = {
  key: 1,
  class: "right_logo",
  src: _imports_2,
  alt: ""
};
const _hoisted_3 = {
  key: 2,
  class: "right_logo",
  src: _imports_3,
  alt: ""
};
const _hoisted_4 = {
  class: "popup"
};
const _hoisted_5 = {
  key: 0,
  src: _imports_4,
  alt: ""
};
const _hoisted_6 = {
  key: 1,
  src: _imports_5,
  alt: ""
};
const _hoisted_7 = {
  class: "collapse_label"
};
const _hoisted_8 = {
  class: "collapse_label"
};
const _hoisted_9 = {
  class: "collapse_label"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_collapse_item = _resolveComponent("van-collapse-item");
  const _component_van_collapse = _resolveComponent("van-collapse");
  const _component_van_popup = _resolveComponent("van-popup");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", {
    class: _normalizeClass($props.hasScroll || $data.showPopup || $data.isFree ? 'navLayout scrollNav' : 'navLayout'),
    onClick: _cache[0] || (_cache[0] = (...args) => $options.open && $options.open(...args))
  }, [_cache[8] || (_cache[8] = _createElementVNode("img", {
    class: "logo",
    src: _imports_0,
    alt: ""
  }, null, -1)), !$data.showPopup && !$props.hasScroll && !$data.isFree ? (_openBlock(), _createElementBlock("img", _hoisted_1)) : _createCommentVNode("", true), !$data.showPopup && ($props.hasScroll || $data.isFree) ? (_openBlock(), _createElementBlock("img", _hoisted_2)) : _createCommentVNode("", true), $data.showPopup ? (_openBlock(), _createElementBlock("img", _hoisted_3)) : _createCommentVNode("", true)], 2), _createVNode(_component_van_popup, {
    show: $data.showPopup,
    position: "top",
    style: {
      "top": "3.13rem",
      "height": "calc(100vh - 3.13rem)"
    }
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", {
      class: "popup_item",
      style: _normalizeStyle($data.active == 'home' ? 'color:#1C2946;' : ''),
      onClick: _cache[1] || (_cache[1] = $event => $options.navto('index'))
    }, " 首页 ", 4), _createVNode(_component_van_collapse, {
      modelValue: $data.activeName,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $data.activeName = $event),
      onChange: $options.changeCollapse,
      border: false
    }, {
      default: _withCtx(() => [_createVNode(_component_van_collapse_item, {
        name: "1"
      }, {
        title: _withCtx(() => [_createElementVNode("div", {
          class: "collapse_title",
          style: _normalizeStyle($data.active == 'normal' || $data.active == 'batch' || $data.active == 'delivery' ? 'color:#1C2946;' : '')
        }, [_cache[9] || (_cache[9] = _createTextVNode(" 解决方案 ", -1)), !$data.openCollapse ? (_openBlock(), _createElementBlock("img", _hoisted_5)) : (_openBlock(), _createElementBlock("img", _hoisted_6))], 4)]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", {
          style: _normalizeStyle($data.active == 'normal' ? 'opacity: 1;' : ''),
          onClick: _cache[2] || (_cache[2] = $event => $options.navto('normal'))
        }, " 通用场景 ", 4)]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", {
          style: _normalizeStyle($data.active == 'batch' ? 'opacity: 1;' : ''),
          onClick: _cache[3] || (_cache[3] = $event => $options.navto('batch'))
        }, " 档口批发 ", 4)]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", {
          style: _normalizeStyle($data.active == 'delivery' ? 'opacity: 1;' : ''),
          onClick: _cache[4] || (_cache[4] = $event => $options.navto('delivery'))
        }, " 分拣配送 ", 4)])]),
        _: 1
      })]),
      _: 1
    }, 8, ["modelValue", "onChange"]), _createElementVNode("div", {
      class: "popup_item",
      style: _normalizeStyle($data.active == 'aboutUs' ? 'color:#1C2946;' : ''),
      onClick: _cache[6] || (_cache[6] = $event => $options.navto('aboutUs'))
    }, " 关于我们 ", 4), _createElementVNode("div", {
      class: "popup_item",
      style: _normalizeStyle($data.active == 'free' ? 'color:#1C2946;' : ''),
      onClick: _cache[7] || (_cache[7] = $event => $options.navto('free'))
    }, " 免费使用 ", 4)])]),
    _: 1
  }, 8, ["show"])], 64);
}